import * as actionTypes from './actionTypes'

export const formWidgetChangeFilter = (path, field, value) => (dispatch) =>
  dispatch({
    type: actionTypes.FORM_CHANGE_FILTER,
    payload: {
      path,
      field,
      value,
    },
  })

export const formWidgetChangeField = (path, field, value) => (dispatch) =>
  dispatch({
    type: actionTypes.FORM_CHANGE_FIELD,
    payload: {
      path,
      field,
      value,
    },
  })

export const powerTableSelectionStatus = (path, selection, uid) => (dispatch) =>
  dispatch({
    type: actionTypes.PT_CHANGE_SELECTION,
    payload: {
      path,
      selection,
      uid,
    },
  })
